import React, { useState } from "react";
import ExportEmailForm from "./ExportEmailForm";
import { useApi } from "../../../api";
import { setFieldErrorsFromResponse } from "../../../utils/formErrors";

const ExportEmailContainer = ({ onClose }) => {
  const api = useApi();
  const [isSubmitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);

  const setFieldError = (field, message) => {
    if (field === "email") {
      setError(message);
    }
  };

  const handleSubmit = email => {
    setSubmitting(true);
    setError(null);

    api
      .put("/v2/users/me/email", { email })
      .then(() => {
        setSubmitting(false);
        onClose(true);
      })
      .catch(e => {
        setSubmitting(false);
        if (!e.response) {
          return;
        }
        setFieldErrorsFromResponse(e.response, setFieldError);
      });
  };

  return (
    <ExportEmailForm
      onClose={onClose}
      onSubmit={handleSubmit}
      isSubmitting={isSubmitting}
      error={error}
    />
  );
};

export default ExportEmailContainer;
